import { useState } from "react";

type ModalState = {
  showBMHModal: boolean;
  bmhPopUp: boolean;
  showAskSupplierModal: boolean;
  iFramePopUp: boolean;
  showLabgrownPopup: boolean;
  showSuccessPopup: boolean;
  showButtonsOptions: boolean;
  showStoneToSettingPopup: boolean;
};

const initialState: ModalState = {
  showBMHModal: false,
  bmhPopUp: false,
  showAskSupplierModal: false,
  iFramePopUp: false,
  showLabgrownPopup: false,
  showSuccessPopup: false,
  showButtonsOptions: false,
  showStoneToSettingPopup: false,
};

export const usePdpModals = () => {
  const [modals, setModals] = useState<ModalState>(initialState);

  return {
    modals,
    setModals,
  };
};
